// @flow

import { graphql } from 'react-relay';
import createRelayMutation from 'shared/gql/createRelayMutation';

const mutation = graphql`
  mutation UpdateShipmentMutation($input: UpdateShipmentInput!) {
    updateShipment(input: $input) {
      error
      shipmentEdge {
        node {
          id
          shipmentNumber
          status
          carrierName
          trackingNumber
          shippingMethod
          shippingAddressLine1
          shippingAddressLine2
          shippingAddressLine3
          shippingAddressCity
          shippingAddressState
          shippingAddressZip
          estimatedShipDate
          actualShipDate
          estimatedDeliveryDate
          actualDeliveryDate
          notes
          packageWeight
          packageLength
          packageWidth
          packageHeight
          shippingCost
          serviceType
          serviceName
          shippingLabelUrl
          trackingNumber
          upsShipmentId
          order {
            id
            orderNumber
          }
          customer {
            id
            name
          }
          updatedAt
          createdAt
        }
      }
    }
  }
`;

export default {
  commit: createRelayMutation.bind(null, mutation),
};
